var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsArray, IsBoolean, IsNumber, IsObject, IsOptional, IsString } from 'class-validator';
import { CreateProfileDto } from '../profile';
import { LanguageLevel } from './manfredite-language/manfredite-language.interface';
export class ManfrediteLanguageLevelUpdateRequest {
    static _OPENAPI_METADATA_FACTORY() {
        return { languageId: { required: true, type: () => Number }, level: { required: true, enum: require("./manfredite-language/manfredite-language.interface").LanguageLevel } };
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ManfrediteLanguageLevelUpdateRequest.prototype, "languageId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ManfrediteLanguageLevelUpdateRequest.prototype, "level", void 0);
export class ManfrediteDto extends CreateProfileDto {
    static _OPENAPI_METADATA_FACTORY() {
        return { goodPractices: { required: false, type: () => Object }, salaryComments: { required: false, type: () => Object }, locationsComments: { required: false, type: () => Object }, careerGoals: { required: false, type: () => Object }, introduction: { required: false, type: () => Object }, phone: { required: false, type: () => String }, communicationPolicy: { required: false, type: () => Object }, salaryId: { required: false, type: () => Number }, experienceId: { required: false, type: () => Number }, roles: { required: false, type: () => [Number] }, techs: { required: false, type: () => [Number] }, locations: { required: false, type: () => [Object] }, languages: { required: false, type: () => [require("./manfredite.dto").ManfrediteLanguageLevelUpdateRequest] }, softSkills: { required: false, type: () => [Number] }, locationTypeRemote: { required: false, type: () => Boolean }, locationTypePartiallyRemote: { required: false, type: () => Boolean }, locationTypeFaceToFace: { required: false, type: () => Boolean }, locationAnywhere: { required: false, type: () => Boolean }, savedByManfredite: { required: false, type: () => Boolean }, facts: { required: false, type: () => [Object] }, avatarId: { required: false, type: () => Number }, techsLike: { required: false, type: () => [Number] }, techsDislike: { required: false, type: () => [Number] }, headline: { required: false, type: () => Object }, whereDoYouLive: { required: false, type: () => Object }, cvFileId: { required: false, type: () => Number }, macFileId: { required: false, type: () => Number }, configuration: { required: false, type: () => Object }, onboarding: { required: false, type: () => Boolean }, currentSalary: { required: false, type: () => Number } };
    }
}
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "goodPractices", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "salaryComments", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "locationsComments", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "careerGoals", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "introduction", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], ManfrediteDto.prototype, "phone", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsObject(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "communicationPolicy", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], ManfrediteDto.prototype, "salaryId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsNumber(),
    __metadata("design:type", Number)
], ManfrediteDto.prototype, "experienceId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "roles", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "techs", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "locations", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "languages", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "softSkills", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ManfrediteDto.prototype, "locationTypeRemote", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ManfrediteDto.prototype, "locationTypePartiallyRemote", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ManfrediteDto.prototype, "locationTypeFaceToFace", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ManfrediteDto.prototype, "locationAnywhere", void 0);
__decorate([
    IsOptional(),
    __metadata("design:type", Boolean)
], ManfrediteDto.prototype, "savedByManfredite", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "facts", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteDto.prototype, "avatarId", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "techsLike", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], ManfrediteDto.prototype, "techsDislike", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "headline", void 0);
__decorate([
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "whereDoYouLive", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteDto.prototype, "cvFileId", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteDto.prototype, "macFileId", void 0);
__decorate([
    Expose(),
    IsObject(),
    IsOptional(),
    __metadata("design:type", Object)
], ManfrediteDto.prototype, "configuration", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], ManfrediteDto.prototype, "onboarding", void 0);
__decorate([
    Expose(),
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], ManfrediteDto.prototype, "currentSalary", void 0);
//# sourceMappingURL=manfredite.dto.js.map